import { type ReactNode } from 'react';
import clsx from 'clsx';
import styles from './Tag.module.css';

interface Props {
  children: ReactNode;
  variant?: 'default' | 'accent' | 'subtle' | 'success' | 'danger' | 'warning';
  size?: 'sm' | 'md';
  className?: string;
}

export const Tag = ({ children, variant = 'default', size = 'sm', className }: Props) => {
  return (
    <span
      className={clsx(
        styles.tag,
        styles[`variant-${variant}`],
        styles[`size-${size}`],
        className,
      )}
    >
      {children}
    </span>
  );
};
